import { capitalizeFirstLetter } from "./text";

const toDisplayMessage = (message) => {
	if (typeof message !== "string" || message.length === 0) {
		return null;
	}

	return capitalizeFirstLetter(message);
};

export const handleAxiosError = (error) => {
	const responseData = error?.response?.data;

	if (responseData != null) {
		if (typeof responseData === "string") {
			const message = toDisplayMessage(responseData);
			if (message) return message;
		} else if (typeof responseData === "object") {
			const message = toDisplayMessage(responseData.message);
			if (message) return message;
		}
	}

	const fallbackMessage = toDisplayMessage(error?.message);
	if (fallbackMessage) return fallbackMessage;

	return "An unknown error occurred";
};
